import styled, { css } from 'styled-components';

import ZIndexLayers from '../../../services/ZIndexLayers';
import { ThemeProp } from '../../../theme/Themes';

interface TagsContainerProps {
  $isTooltip?: boolean;
  $wrap?: boolean;
}

export const TagsContainer = styled.div<TagsContainerProps>`
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.625rem;
  overflow: hidden;
  width: 100%;
  flex-wrap: ${(props: TagsContainerProps) => (props.$isTooltip || props.$wrap ? 'wrap' : 'nowrap')};
  ${(props: TagsContainerProps) =>
    !props.$isTooltip &&
    css`
      :after {
        content: '';
        background: ${(props: ThemeProp) => props.theme.gradients.overflowGradient};
        z-index: ${ZIndexLayers.overlay};
        position: absolute;
        right: 0;
        height: 100%;
        width: 2rem;
      }
    `};
`;

export const TagChip = styled.div`
  border-radius: ${(props: ThemeProp) => props.theme.borderRadius};
  background: ${(props: ThemeProp) => props.theme.colors.neutrals.c100};
  padding: 0.125rem 0.25rem;
  font-size: ${(props: ThemeProp) => props.theme.fontSize.xxs};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.medium};
  line-height: ${(props: ThemeProp) => props.theme.lineHeight.xxs};
  letter-spacing: 0.03125rem;
  text-transform: uppercase;
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.c500};
  flex-shrink: 0;
`;
